var Mycroft = {

	// Values that can be set directly on Mycroft:
	//   - userData. Hash of data about the current user
	//   - splitTest
	//   - forcedVariations
	//   - isDisabled

	init: function(gaID, ops) {
		ops = ops || {};
		var scriptContent = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');";

		if (ops.onLocalhost) {
			scriptContent += "ga('create', '" + gaID + "', {'cookieDomain': 'none'});";
		} else {
			scriptContent += "ga('create', '" + gaID + "', 'auto');";
		}

		// // We're doing this manually instead:
		// scriptContent += "ga('send', 'pageview');";

		$("head").append("<script>" + scriptContent + "</script>");

		this.newPage(document.location.pathname);
	},

	initExceptionTracking: function() {
		if (!Mycroft.isInitialized() || Mycroft.isDisabled) { return; }

		window.addEventListener('error', function(err) {
			ga('send', 'exception', {
				'exDescription': err.message,
				'exFatal': false
			});
		});
	},

	setUserData: function(userData, splitTests) {
		if (userData && userData.disableMycroft) {
			Mycroft.isDisabled = true;
		}
		if (!Mycroft.isInitialized() || Mycroft.isDisabled) { return; }

		Mycroft.userID = userData.id;
		Mycroft.splitTests = splitTests;

		// Set user custom dimensions
		Mycroft.setDimension(11, userData.grade_level);
		Mycroft.setDimension(12, userData.role);

		Mycroft.setDimension(13, userData.product);

		if (userData.source_data) {
			if (userData.source_data.source) {
				Mycroft.setDimension(14, userData.source_data.source);				
			} else {
				Mycroft.setDimension(14, "None");
			}
		}

		ga('set', 'userId', userData.id);

		Mycroft.newEvent({ category: "Split Test", action: "loading",
			fieldsObject: { nonInteraction: 1 } });

		for (var i=0; i < splitTests.length; i++) {
			var test = splitTests[i];
			Mycroft.setDimension(test.dimension_index, test.variation);

			// Mycroft.newEvent({ category: "Split Test", action: test.name, 
			// 	label: test.full_variation, fieldsObject: { nonInteraction: 1 } });
		}
		Mycroft.newEvent({ category: "Split Test", action: "Loaded",
			fieldsObject: { nonInteraction: 1 } });

	},

	isInitialized: function() {
		return typeof ga != "undefined";
	},

	setDimension: function(index, value) {
		if (!Mycroft.isInitialized() || Mycroft.isDisabled) { return; }
		ga('set', ("dimension" + index), value);
	},

	newPage: function(path) {
		if (!Mycroft.isInitialized() || Mycroft.isDisabled) { return; }
		path = path.replace(/\/\d+$/g, "/:id");
		path = path.replace(/\/\d+\//g, "/:id/");

		ga('set', 'page', path);
		ga('send', 'pageview');
	},

	// Takes hash: { category: "..", action: "..", label: '..' value: "..", fieldsObject: {} }
	// 'category' and 'action' are required, 'label' is recommended
	// IMPORTANT: refer to Event Schema before adding new events (ask Greg)
	newEvent: function(eventData) {
		if (!Mycroft.isInitialized() || Mycroft.isDisabled) { return; }
		if ((eventData.category || "").trim().length == 0 || (eventData.action || "").trim().length == 0) {
			console.error("eventData must define non-empty 'category' and 'action:'", eventData);
			return;
		}

		ga('send', 'event', eventData.category, eventData.action,
			eventData.label, eventData.value, (eventData.fieldsObject || {}));
	},

	buildEventHandler: function(eventData) {
		return function(e) {
			// DO NOT: e.preventDefault()
			Mycroft.newEvent(eventData)
		}
	},

	isActiveVariation(testName, testVariation) {
		if (Mycroft.splitTests == undefined) { return; }

		if (Mycroft.forcedVariations && Mycroft.forcedVariations[testName]) {
			return Mycroft.forcedVariations[testName] == testVariation;
		} else {
			var test = _.findWhere(Mycroft.splitTests, { name: testName });
			if (test) {
				return test.variation == testVariation;
			}			
		}
	},

	forceVariation(testName, testVariation) {
		Mycroft.forcedVariations = Mycroft.forcedVariations || {};
		Mycroft.forcedVariations[testName] = testVariation;
	}
}

module.exports = Mycroft;


// WEBPACK FOOTER //
// ./modules/lib/integrations/Mycroft.js